import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PreviewRoutingModule } from './preview-routing.module';
import { PreviewComponent } from '../verify/preview.component';
import { SharedModule } from '@app/sharedModule/shared.module';
import { AutomationRulesFeatureModule } from '@app/features/automation-rules/automation-rules.module';
import { ActionContainerComponent } from './components/action-container/action-container.component';
import { PreviewOrdersEffects } from './store/effects';
import * as fromPreview from './store/reducers';
import { StorybookModule } from '@storybook/storybook.module';
import { ManualVerifyDialog } from '@pages/workspace/verify/dialog/manual-verify/manual-verify.dialog';
import { SyncOrdersComponent } from './components/sync-orders/sync-orders.component';
import { IFilterUniqueOptions, IFilterOptionPipe } from './components/sync-orders/pipes/pipes';
@NgModule({
  declarations: [
    PreviewComponent,
    ActionContainerComponent,
    ManualVerifyDialog,
    SyncOrdersComponent,
    IFilterUniqueOptions,
    IFilterOptionPipe,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PreviewRoutingModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    AutomationRulesFeatureModule,
    StoreModule.forFeature(fromPreview.featureKey, fromPreview.reducers),
    EffectsModule.forFeature([PreviewOrdersEffects]),
    StorybookModule,
  ],
})
export class PreviewModule {}
